import FileChooser from './FileChooser';

export default FileChooser;
